import React, {Component} from 'react';
import {Modal, Table} from 'react-bootstrap';
import {translate} from 'react-i18next';
import FlatButton from 'material-ui/FlatButton';
import swal from 'sweetalert';
import moment from 'moment';

const Config = require('../../config');

class DetailsExtraction extends Component{
	constructor(props){
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);

		this.state = {
			show:  false, 
			staff:[],
			medical_staff_id:"",
			extraction:"",
			blood_bags:[], 
			blood_bags_id:"",
			volume:"",
			unit:[],
			double:false,
			component_kit:[],
			apheresis:[],
			apheresis_kits_id:"",
			duration:"",

			timestamp_date:"",
			timestamp_hour:"",
			time_start:"",
			time_end:"",
			equipment_id:"",
			arm:"",
			tube:"",
			bag_flag:"",
			lote_anticoagulant:"",
			vol_anticoagulant:"",
			cycle_number:"",
			proceced_blood:"",
			platelet_performance:"",
			equivalent_unit:"",
			lote_number:"",

			arms:[],
		}
	}

	componentDidMount(){
		this.props.onRef(this);

		fetch(Config.default.apiGateway.URL+'medical_staff?option=byType&type=NURSE', {
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept' 		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response =>{
			this.setState({staff: response});
		})

		//lookups?type=arm_type&notrender=0 brazo
		fetch(Config.default.apiGateway.URL+'lookups?type=arm_type&notrender=0',{
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer ' + sessionStorage.getItem("token"),
				'Accept' 		: 'application/json',
				'Content-Type'	: 'application/json', 
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			this.setState({arms: response});
		});
	}

	componentWillUnmount(){
		this.props.onRef(null);
	}

	handleShow(donor, offer, ex){
		this.props.waiting.handleShow('Cargando...');
		this.setState({extraction:ex});

		fetch(Config.default.apiGateway.URL+'donations?id='+donor,{
			method:'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){

				var i_arm = this.state.arms.findIndex(obj => (obj.key).toUpperCase() === response.donation.arm);
				
				this.setState({
					medical_staff_id: response.donation.users_id,
					blood_bags_id: response.donation.blood_bags_id,
					volume: response.donation.volume,
					apheresis_kits_id:response.donation.apheresis_kits_id !== null ? response.donation.apheresis_kits_id : "",
					duration: response.donation.extraction_time,
					timestamp_date:moment(response.donation.timestamp_date).format('DD/MM/YYYY'),
					timestamp_hour:moment(response.donation.timestamp_hour, 'H:mm:ss').format('HH:mm'),
					time_start:moment(response.donation.time_start).format('HH:mm'),
					time_end:moment(response.donation.time_end).format('HH:mm'),
					equipment_id:response.donation.equipment_id,
					arm:i_arm === -1 ? '' : this.state.arms[i_arm].name,
					tube:response.donation.tube === 0 ? 'SI' : response.donation.tube === 1 ? 'NO' : '',
					bag_flag:response.donation.bag_flag === 1 ? 'SI' : response.donation.bag_flag === 0 ? 'NO' : '',
					lote_number:response.donation.lote_number,
					lote_anticoagulant:response.donation.lote_anticuagulant,
					vol_anticoagulant:response.donation.volume_anticoagulant,
					cycle_number:response.donation.cycle_number,
					proceced_blood:response.donation.proceced_blood,
					platelet_performance:response.donation.platelet_performance,
					equivalent_unit:response.donation.equivalent_units
				});

				if(response.unit.length > 0){

					var units = [];
					response.unit.map((u, i)=>{
						if(response.donation.volume === null){
							var volume = u.volume;
						}else{
							volume = response.donation.volume;
						}				

						if(units.length === 0){
							units.push([{
								unit:1,
								donation_id:u.donation_id,
								id:u.id,
								blood_component_id:u.blood_component_id, 
								volume:parseInt(volume),
								current_unit:u.current_unit,
								unit_number: response.donation.donation_number,
								component_number:u.component_number,
								caducidad:u.caducidad
							}])
						}else{
							
							var bool = units.some(function(arr) {
							  return arr.every(function(prop, index) {
							    return u.blood_component_id === prop.blood_component_id
							  })
							});

							if(bool){
								units.some(function(arr) {
								  	return arr.every(function(prop, index) {
								    	return u.blood_component_id === prop.blood_component_id ?
								    		arr.push({
												unit:prop.unit+1,
												donation_id:u.donation_id,
												id:u.id,
												blood_component_id:u.blood_component_id, 
												volume:parseInt(volume),
												current_unit:u.current_unit,
												unit_number: response.donation.donation_number,
												component_number:u.component_number,
												caducidad:u.caducidad
											})
								    	: null
								  	})
								})
							}else{
								units.push([{
									unit:1,
									donation_id:u.donation_id,
									id:u.id,
									blood_component_id:u.blood_component_id, 
									volume:parseInt(volume),
									current_unit:u.current_unit,
									unit_number: response.donation.donation_number,
									component_number:u.component_number,
									caducidad:u.caducidad
								}])
							}
						}
					})

					var double = false;
					units.map((item)=>{
						if(item.length === 1){
							item.push({
								unit:item[0].unit+1,
								donation_id:item[0].donation_id,
								id:item[0].id,
								blood_component_id:item[0].blood_component_id, 
								volume:"",
								current_unit:item[0].current_unit,
								unit_number: item[0].donation_number,
								component_number:item[0].component_number,
								caducidad:item[0].caducidad
							})
						}else{
							double = true;
						}
					})

					this.setState({
						unit: units,
						double:double
					})
				}

				if(ex !== 'ST'){
					setTimeout(()=>{
						this.getApheresis();

					}, 500);
				}
			}
		})

		

		fetch(Config.default.apiGateway.URL+'blood_bags/by_hf/'+sessionStorage.getItem('health_facilities_id'), {
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer ' + sessionStorage.getItem("token"),
				'Accept'	 	: 'application/json',
				'Content-Type' 	: 'application/json'
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			this.setState({
				blood_bags: response,
				show: true
			})

		})
		
	}

	getApheresis(){
		//apheresis_kits
		fetch(Config.default.apiGateway.URL+'apheresis_kits',{
			method: 'get',
			headers: new Headers({
				'Authorization' : 'Bearer ' + sessionStorage.getItem("token"),
				'Accept' 		: 'application/json',
				'Content-Type'	: 'application/json', 
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			this.setState({apheresis: response});

			response.map((a)=>{
				if(a.apheresis_kit.id === this.state.apheresis_kits_id){

					this.setState({
						component_kit:a.asigned_components.components,
						asigned_kit: a.asigned_components.asigned
					})
				}
			})				
		})
	}

	handleClose(){
		this.setState({show: false});
	}

	render(){
		const {t} = this.props;

		return (
			<Modal bsSize={this.state.extraction !== 'ST' ? 'lg' : ''} show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>Detalles de Extracción</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row">
		        		<div className="col-xs-12">
		        			<div className={this.state.extraction !== 'ST' ? "col-xs-12 col-sm-4" : 'col-xs-12 col-sm-8'}>
		        				<span className="span-min">Responsable</span>
								<select className="form-control" value={ this.state.medical_staff_id} 
									onChange={(e)=>e.preventDefault() } name="medical_staff_id" id="medical_staff_id"
									disabled>
									<option value="">Seleccionar...</option>
									{this.state.staff.map((t) => (
										<option key={t.medical_staff.id} value={t.medical_staff.id} >
											{t.medical_staff.code?t.medical_staff.code+' - ':""} 
											{' '+t.medical_staff.names+' '} 
											{t.medical_staff.lastname1?t.medical_staff.lastname1+' ': ""} 
											{t.medical_staff.lastname2?t.medical_staff.lastname2: ""}
										</option>
									))}
								</select>
		        			</div>

		        			{this.state.extraction !== 'ST'?
		        				<div>
		        					<div className="col-xs-12 col-sm-4">
				        				<div style={{textAlign:'center'}}>
				        					<span className="span-min">F. Extracción</span>
				        				</div>
				        				<div className="col-xs-12 col-sm-6" style={{paddingLeft: "0px"}}>
				        					<input type="text" name="timestamp_date" className="form-control"
												value={this.state.timestamp_date} id="timestamp_date" 
												style={{padding:"5px"}} disabled />
				        				</div>
				        				<div className="col-xs-12 col-sm-6" style={{paddingRight: "0px"}}>
				        					<input type="text" id="timestamp_hour" name="timestamp_hour"  
												value={this.state.timestamp_hour || ""} style={{padding:"5px"}} disabled
												className="form-control"/>
				        				</div>
				        			</div>

				        			<div className="col-xs-12 col-sm-2">
				        				<span className="span-min">Hr. Inicial</span>
			        					<input type="text" name="time_start" className="form-control"
											value={this.state.time_start} id="time_start" 
											disabled />
			        				</div>
			        				<div className="col-xs-12 col-sm-2">
				        				<span className="span-min">Hr. Final</span>
			        					<input type="text" name="time_end" className="form-control"
											value={this.state.time_end} id="time_end" 
											disabled />
			        				</div>

		        				</div>
		        			:<div className="col-xs-12 col-sm-4">
		        				<span className="span-min">Duración</span>
		        				<input disabled type="text" name="duration" value={this.state.duration}
		        					onChange={(e)=>e.preventDefault()} className="form-control" />
		        			</div>}
			        			

		        			
		        		</div>

		        		{this.state.extraction !== 'ST' ?
	        				<div className="col-xs-12">
		        			
			        			<div className="col-xs-12 col-sm-2">
			        				<span className="span-min">Separador Celular</span>
			        				<input disabled type="text" name="equipment_id" id="equipment_id" 
			        					value={this.state.equipment_id || ""} className="form-control" />
			        			</div>
			        			<div className="col-xs-12 col-sm-2">
			        				<span className="span-min">Brazo</span>
			        				<input disabled type="text" name="arm" id="arm" value={this.state.arm}
			        					className="form-control" />
			        			</div>
			        			<div className="col-xs-12 col-sm-2">
			        				<span className="span-min">Tubo</span>
			        				<input disabled type="text" name="tube" id="tube" value={this.state.tube}
			        					className="form-control" />
			        			</div>
			        			<div className="col-xs-12 col-sm-2">
			        				<span className="span-min">Bolsa</span>
			        				<input disabled type="text" name="bag_flag" id="bag_flag" value={this.state.bag_flag}
			        					className="form-control" />
			        			</div>
			        			<div className="col-xs-12 col-sm-2">
			        				<span className="span-min">Kit Lote No.</span>
			        				<input disabled type="text" name="lote_number" id="lote_number" value={this.state.lote_number}
			        					className="form-control" />
			        			</div>		        			
			        		
			        			<div className="col-xs-12 col-sm-2">
			        				<span className="span-min">Duración</span>
			        				<input disabled type="text" name="duration" value={this.state.duration}
			        					onChange={(e)=>e.preventDefault()} className="form-control" />
			        			</div>
		        			</div>
		        		:null}

		        		{this.state.extraction !== 'ST' ?
	        				<div className="col-xs-12">
		        			
			        			<div className="col-xs-12 col-sm-2">
			        				<span className="span-min">Anticoagulante Lote</span>
			        				<input disabled type="text" name="lote_anticoagulant" id="lote_anticoagulant" 
			        					value={this.state.lote_anticoagulant} className="form-control" />
			        			</div>
			        			<div className="col-xs-12 col-sm-2">
			        				<span className="span-min">Vol. Anticoagulante(ml)</span>
			        				<input disabled type="text" name="vol_anticoagulant" id="vol_anticoagulant" 
			        					value={this.state.vol_anticoagulant}
			        					className="form-control" />
			        			</div>
			        			<div className="col-xs-12 col-sm-2">
			        				<span className="span-min">No. Ciclos</span>
			        				<input disabled type="text" name="cycle_number" id="cycle_number" value={this.state.cycle_number}
			        					className="form-control" />
			        			</div>
			        			<div className="col-xs-12 col-sm-2">
			        				<span className="span-min">Sangre Procesada</span>
			        				<input disabled type="text" name="proceced_blood" id="proceced_blood" value={this.state.proceced_blood}
			        					className="form-control" />
			        			</div>
			        			<div className="col-xs-12 col-sm-2">
			        				<span className="span-min">Rendimiento Plaquetas</span>
			        				<input disabled type="text" name="platelet_performance" id="platelet_performance" value={this.state.platelet_performance}
			        					className="form-control" />
			        			</div>		        			
			        		
			        			<div className="col-xs-12 col-sm-2">
			        				<span className="span-min">Unid. Equivalentes</span>
			        				<input disabled type="text" name="equivalent_unit" value={this.state.equivalent_unit}
			        					className="form-control" />
			        			</div>
		        			</div>
		        		:null}



		        		{this.state.extraction === 'ST'?
		        			<div className="col-xs-12">
		        				<div className="col-xs-12 col-sm-8">
		        					<span className="span-min">Tipo de Bolsa</span>
		        					<select disabled className="form-control" value={ this.state.blood_bags_id} 
										onChange={(e)=>e.preventDefault()} name="blood_bags_id" 
										id="blood_bags_id">
										<option value="" disabled>Seleccionar...</option>
										{this.state.blood_bags.map((t)=>(
											<option key={t.blood_bag.id} value={t.blood_bag.id} >{t.blood_bag.name}</option>
										))}
									</select>
		        				</div>

		        				<div className="col-xs-12 col-sm-4">
		        					<span className="span-min">Volumen</span>
		        					<input disabled type="text" className="form-control" id="volume" name="volume" 
		        						value={this.state.volume} onChange={(e)=>e.preventDefault()} />
		        				</div>
		        			</div>
		        		: <div>
		        			<div className="col-xs-12">
		        				<div className="col-sm-6">
						        	<span className="span-min">{t('content.extractions.apheresis.apheresis_kits_id')}</span>
									<select disabled className="form-control" value={ this.state.apheresis_kits_id } 
							        	onChange={(e)=>e.preventDefault()} name="apheresis_kits_id" 
							        	id="apheresis_kits_id">
						              	<option value="" disabled>Seleccionar...</option>
						                {this.state.apheresis.map((t)=>(
						                	<option key={t.apheresis_kit.id} value={t.apheresis_kit.id} >{t.apheresis_kit.name}</option>
						                ))}
						            </select>
						        </div>
					        </div>
					        <div className="col-xs-12">
						       	<Table resposive hover>
						       		<thead>
						       			<tr>
						       				<th>Tipo Bolsa</th>
						       				<th>Bolsa</th>
						       				{this.state.double ?
						       					<th>Bolsa 2</th>
						       				:null}
						       			</tr>
						       		</thead>
						       		<tbody>
						       			{this.state.component_kit.map((c, i)=>(
						       				<tr key={i}>
						       					<td>{c.component}</td>
						       					{this.state.unit[i] !== undefined ?
										        	this.state.unit[i].map((u, j)=>(
										        		this.state.double ?
							        						<td>{u.volume || ""}</td>
							        					: j === 0 ?
							        						<td>{u.volume || ""}</td>
							        					:null
										        	))
										        :null}
						       				</tr>
						       			))}
						       		</tbody>
						       	</Table>
					        	{/*this.state.component_kit.map((c, i)=>(
					        		
					        	
							        <div className="col-xs-12" key={c.id} style={{marginTop:'17px'}}>
								        <div className={this.state.double ? "col-xs-6" : "col-xs-8"}>
								        	<span className="span-min">{c.component}</span>
								        </div>
								        {this.state.unit[i] !== undefined ?
								        	this.state.unit[i].map((u, j)=>(
								        		this.state.double ?
					        						<div key={j} className={this.state.double ? "col-xs-3" : "col-xs-4"}> 
						        						<input disabled type="number" 
						        							className="form-control volume-unit" 
															name={'vol_'+this.state.asigned_kit[i].blood_component_id+'_'+u.unit}
															value={u.volume || ""} 
															onChange={(e)=>e.preventDefault()}
															placeholder={t('content.extractions.components_kit.volumen')} />
						        					</div>
					        					: j === 0 ?
					        						<div key={j} className={this.state.double ? "col-xs-3" : "col-xs-4"}> 
						           						<input disabled type="number"
						        							className="form-control volume-unit" 
															value={u.volume || ""} 
															onChange={(e)=>e.preventDefault()}
															name={'vol_'+this.state.asigned_kit[i].blood_component_id+'_'+u.unit}
															placeholder={t('content.extractions.components_kit.volumen')}/>
						        						
						        					</div>
					        					:null
								        	))
								        :null}								        		
								    </div>
								))*/}
						       
					        </div>
					    </div>}
					</div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.close')} onClick={this.handleClose}  />
		        </Modal.Footer>
	      	</Modal>
		)
	}
}

export default translate('translations') (DetailsExtraction);
